import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth/AuthProvider';

export function AuthGuard() {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="flex-1 flex items-center justify-center text-[var(--color-muted-foreground)]">
        불러오는 중...
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/app/login" replace />;
  }

  return <Outlet />;
}
